
import { Box, Heading, Image, } from "@chakra-ui/react";
export default function MyServicesPlaceHolder() {

  return (

    <Box h="100vh" w="100%">
      {/* Header */}
      <Box
        alignItems="center"
        justifyContent="space-between"
        display="flex"
        color="rgba(11,78,90,255)"
        bgColor="#f6f3ec"
        p="4"
      >
        <Heading size="xl" color="rgba(11,78,90,255)">
          My Services
        </Heading>
      </Box>

      {/* Centered Box */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        bg="blue.50"
        p="6"
        borderRadius="md"
        boxShadow="md"
        textAlign="center"
      >
        <Heading size="md" color="blue.800">
          Work in progress...
        </Heading>
      </Box>

    </Box>
  )

}